import { gql } from 'graphql-request';
import { graphQLApi } from 'utils/Api';
import {
  PayrollGetPerquisiteComponentQueryVariables,
  PayrollGetPerquisiteComponentResponse,
} from './types';

export const getPerquisiteComponentQuery = gql`
  query PayrollGetPerquisiteComponent($id: String!) {
    payrollGetPerquisiteComponentDetails(id: $id) {
      data {
        id
        name
        displayName
        description
        isSystemDefault
        status
        showZero
        visibleToEmployee
      }
    }
  }
`;

const getPerquisiteComponent = (queryVariables: PayrollGetPerquisiteComponentQueryVariables) => {
  if (queryVariables.id) {
    return graphQLApi<
      PayrollGetPerquisiteComponentResponse,
      PayrollGetPerquisiteComponentQueryVariables
    >({
      query: getPerquisiteComponentQuery,
      queryVariables,
    });
  } else {
    return Promise.reject('ComponentID is required');
  }
};

export default getPerquisiteComponent;
